"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aliases = void 0;
exports.Aliases = {
    backgroundDark: '#1E1E1E',
    backgroundHighlight: '#3A68FF',
    backgroundLight: '#FFFFFF',
    backgroundLightSecondary: '#F4F4F4',
    badge: '#54C2E8',
    brand: '#FFCC00',
    brandBeacon: '#FAEC20',
    critical: '#E1001A',
    divider: '#D3D2D2',
    dividerAlt: '#4F4C4D',
    highlightCaution: '#FEEFE8',
    highlightNeutral: '#D8EEF9',
    highlightPositive: '#ECFEEC',
    hyperlinkDark: '#1175B5',
    hyperlinkLight: '#FFFFFF',
    information: '#1175B5',
    success: '#00AA00',
    textDark: '#1E1E1E',
    textDarkSecondary: '#706D6E',
    textLight: '#FFFFFF',
    textLightSecondary: '#D3D2D2',
    textLightTertiary: '#F4F4F4',
    textAction: '#1175B5',
    iconCaution: '#F95200',
    iconDark: '#4F4C4D',
    iconDarkSecondary: '#706D6E',
    iconOnHighlight: '#3A68FF',
    infographicCaution: '#F95200',
    textPositive: '#1A7D1A',
};
